"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoToProduct = void 0;
var _mui = require("@ori-ui/mui");
var _contexts = require("../../contexts");
var _useTranslations = require("../../hooks/useTranslations");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const GoToProduct = () => {
  const {
    goToUrl
  } = (0, _contexts.useShadePicker)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
      fontWeight: "bold",
      textTransform: "uppercase",
      color: "textPrimary",
      variant: "button",
      href: goToUrl,
      children: translations.goToProduct
    })
  });
};
exports.GoToProduct = GoToProduct;
//# sourceMappingURL=GoToProduct.js.map